import React from 'react'
import styled, { css } from 'styled-components'
import { Table as TableBase, TableBody as TableBodyBase, TableHead as TableHeadBase } from '@material-ui/core'

export const Root = styled.div`
  height: ${props => props.height};
  margin: ${props => props.margin};
  overflow-y: ${props => (props.height === 'auto' ? 'initial' : 'auto')};
  padding: ${props => props.padding};
  width: 100%;

  ${props => props.theme.breakpoints.only('xs')} {
    overflow-x: auto;
    width: 599.95px;
  }
`

export const BaseTable = styled(({ borderSpacing, children, ...props }) => (
  <TableBase {...props}>{children}</TableBase>
))`
  &.MuiTable-root {
    border-collapse: separate;
    border-spacing: ${props => props.borderSpacing};
    font-family: ${props => props.theme.typography.fontFamily};
    width: 100%;
  }
`

export const BaseTableBody = styled(({ disableLatestBottomBorder, enableCondensed, enableStripped, ...props }) => (
  <TableBodyBase {...props} />
))`
  &.MuiTableBody-root .MuiTableRow-root:nth-of-type(even):not([data-selected~='true']) {
    background-color: ${props => props.enableStripped && props.theme.palette.gray[95]};
  }

  &.MuiTableBody-root .MuiTableRow-root .MuiTableCell-root {
    padding: ${props => (props.enableCondensed ? '3px 8px' : '15px 8px')};
  }

  &.MuiTableBody-root .MuiTableRow-root .MuiTableCell-root:first-of-type {
    padding: ${props => (props.enableCondensed ? '3px 8px 3px 24px' : '15px 8px 15px 24px')};
  }

  &.MuiTableBody-root .MuiTableRow-root .MuiTableCell-root:last-of-type {
    padding: ${props => (props.enableCondensed ? '3px 24px 3px 8px' : '15px 24px 15px 8px')};
  }

  &.MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root {
    ${props =>
      props.disableLatestBottomBorder &&
      css`
        border-bottom: none;
      `}
  }
`

export const BaseTableHead = styled(TableHeadBase)`
  &.MuiTableHead-root {
    background-color: ${props => props.theme.palette.brand.white};
    position: sticky;
    top: 0;
  }

  &.MuiTableHead-root .MuiTableRow-root .MuiTableCell-root {
    border-bottom: 1px solid ${props => props.theme.palette.gray[85]};
    box-sizing: border-box;
    padding: 11px 8px;
  }

  &.MuiTableHead-root .MuiTableRow-root .MuiTableCell-root:first-of-type {
    padding: 11px 8px 11px 24px;
  }

  &.MuiTableHead-root .MuiTableRow-root .MuiTableCell-root:last-of-type {
    padding: 11px 24px 11px 8px;
  }
`
